module.exports = __webpack_public_path__ + "img/programbanner.872806d6.png";